const DetailRow = ({ label, value }) => {
  if (!value || value === "Not Specified" || value === "") return null;

  return (
    <div className="flex justify-between items-start gap-3">
      <span className="text-gray-500 text-sm flex-shrink-0">{label}:</span>
      <span className="text-gray-900 text-sm font-medium text-right break-words">
        {value}
      </span>
    </div>
  );
};
export default DetailRow;
